import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  BulkImportResponse,
  TemplateSample,
  TemplateSampleCreate,
  TemplateSampleUpdate,
} from '../../interfaces/sample.interface';

export const TemplateSampleActions = createActionGroup({
  source: 'templateSamples',
  events: {
    'Load samples': props<{ templateId: string }>(),
    'Load samples success': props<{ samples: TemplateSample[] }>(),
    'Load samples failure': props<{ error: HttpErrorResponse }>(),

    'Load sample': props<{ templateId: string; sampleId: string }>(),
    'Load sample success': props<{ sample: TemplateSample }>(),
    'Load sample failure': props<{ error: HttpErrorResponse }>(),

    'Create sample': props<{ templateId: string; sample: TemplateSampleCreate }>(),
    'Create sample success': props<{ sample: TemplateSample }>(),
    'Create sample failure': props<{
      error: HttpErrorResponse;
      sample: TemplateSampleCreate;
    }>(),

    'Update sample': props<{
      templateId: string;
      sampleId: string;
      sample: TemplateSampleUpdate;
    }>(),
    'Update sample success': props<{ sample: TemplateSample }>(),
    'Update sample failure': props<{
      error: HttpErrorResponse;
      sample: TemplateSampleUpdate;
    }>(),

    Delete: props<{ templateId: string, sampleId: string }>(),
    'Delete success': props<{ id: string }>(),
    'Delete failure': props<{ error: HttpErrorResponse }>(),

    'Bulk import': props<{ templateId: string; file: File }>(),
    'Bulk import success': props<{ response: BulkImportResponse }>(),
    'Bulk import failure': props<{ error: HttpErrorResponse }>(),

    'Clear Samples': emptyProps(),
  },
});
